export enum PositionRunTriggerTypeEnum {
  CreatePosition = 'CREATE_POSITION',
  ManualUpdate = 'MANUAL_UPDATE',
  DeadEndRecommendation = 'DEAD_END_RECOMMENDATION',
  System = 'SYSTEM',
}
